import * as React from 'react';
import * as images from './images';

export type RichIconType = keyof typeof images;

type ImgProps = JSX.IntrinsicElements['img'];

export interface RichIconProps extends ImgProps {
  icon?: RichIconType;
  source?: string;
  size?: number;
  alt?: string;
}

export function RichIcon({
  icon = '',
  source,
  size = 12,
  alt = '',
  ...restProps
} : RichIconProps) {
  const iconSource = source || images[icon] || '';

  return (
    <img
      {...restProps}
      alt={alt}
      height={size}
      width={size}
      src={iconSource}
    />
  );
}

export default RichIcon;
